module.exports = __webpack_public_path__ + "static/img/gxyd_banner.866a347c.jpg";